//
import Model from '@/models/Model'
import DetailProviderPaymentModel from '@/models/Purchase/PchDetailProviderPayment'
import ProviderPaymentPosPaymentTypeModel from '@/models/Purchase/PchProviderPaymentPosPaymentType'

/**
 * This class describes a pch provider payment.
 *
 * @class      PchProviderPayment (name)
 */
export default class PchProviderPayment extends Model {

	/**
	 * { item_description }
	 */
	raw_debt_to_pays = []
	raw_payments = []

	/**
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get raw_resume() {
		return this
			.raw_debt_to_pays
			.map(row => { row.amount_debt = row.amount; return row })
			.concat(this.raw_payments.map(row => { row.amount_paid = row.amount; return row }))
			.reduce(this.reduceResume, [
				{ 
					debt: 0, 
					diff: 0, 
					paid: 0,
				}
			])
	}

	/**
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get pch_provider_business_name() {
		return this.getProperty('pch_provider.business_name', '-')
	}

	/**
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get pch_provider_rut() {
		return this.getProperty('pch_provider.rut', '')
	}

	/**
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get g_user_hr_employee_name_case() {
		return this.getProperty('g_user.hr_employee.name_case', '-')
	}

	/**
	 * { function_description }
	 *
	 * @param      {<type>}  item    The item
	 * @return     {Object}  { description_of_the_return_value }
	 */
	mapDebtToPay(item) {
		return {
			pch_provider_debt_to_pay_id: item.id,
			amount: item.amount,
		}
	}

	/**
	 * { function_description }
	 *
	 * @param      {<type>}                      item    The item
	 * @return     {DetailProviderPaymentModel}  The detail provider payment model.
	 */
	mapDetail(item) {
		return new DetailProviderPaymentModel(item)
	}

	/**
	 * { function_description }
	 *
	 * @return     {Object}  { description_of_the_return_value }
	 */
	mapPayment(item) {

		//
		const isEffective	= item.pos_payment_type.id === 1
		const isCheck			= item.pos_payment_type.id === 4
		const isTransfer	= item.pos_payment_type.id === 6

		//
		return {
			pos_payment_type_id				: item.pos_payment_type.id,
			amount										: item.amount,
			g_bank_id									: isCheck || isTransfer ? item.g_bank.id : undefined,
			account										: isTransfer ? String(item.account_number) : undefined,
			account_number						: isEffective || isTransfer ? undefined : item.account_number,
			plaza											: isEffective || isTransfer ? undefined : item.plaza,
			pos_payment_check_type_id	: isEffective || isTransfer ? undefined : item.pos_payment_check_type.value,
			charge_date								: isEffective || isTransfer ? undefined : item.charge_date,
			serial_number							: isEffective || isTransfer ? undefined : item.serial_number,
		}
	}

	/**
	 * { function_description }
	 *
	 * @param      {<type>}                         item    The item
	 * @return     {ProviderPaymentPosPaymentType}  The provider payment position payment type.
	 */
	mapTypes(item) {
		return new ProviderPaymentPosPaymentTypeModel(item).reset()
	}

	/**
	 * Reduces the resume.
	 *
	 * @param      {<type>}  total   The total
	 * @param      {<type>}  item    The item
	 * @return     {<type>}  { description_of_the_return_value }
	 */
	reduceResume(total, item) {

		//
		//console.log({ item })

		//
		total[0].debt += isNaN(item.amount_debt) ? 0 : Number(item.amount_debt)
		total[0].paid += isNaN(item.amount_paid) ? 0 : Number(item.amount_paid)
		total[0].diff += isNaN(item.amount_debt) ? -Number(item.amount_paid) : Number(item.amount_debt)

		//
		return total
	}

	reset() {

		//
		this.hr_employee = this.getProperty('g_user.hr_employee', {})
		this.pch_detail_provider_payments = this.getProperty('pch_detail_provider_payments', []).map(this.mapDetail)
		this.pch_provider_payment_pos_payment_types = this.getProperty('pch_provider_payment_pos_payment_types', []).map(this.mapTypes)

    console.log(this.pch_provider_payment_pos_payment_types)

		//
		return this
	}

	/**
	 * { function_description }
	 *
	 * @return     {string}  { description_of_the_return_value }
	 */
  resource() {
    return 'pch_provider_payment'
  }

  /**
   * Returns a create representation of the object.
   *
   * @return     {<type>}  Create representation of the object.
   */
  toCreate() {

  	//
  	this.debt_to_pays = this.raw_debt_to_pays.map(this.mapDebtToPay)
  	this.payments = this.raw_payments.map(this.mapPayment)

  	//
  	return this.clean([
  		'pch_provider_id',
  		'debt_to_pays',
  		'payments',
  	])
  }
}